module.exports = __webpack_public_path__ + "static/media/org.13aee7db.svg";